var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isWeixin)?_c('div',{staticClass:"common-header-container",on:{"click":_vm.jumpToCenter}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }